import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";

import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import { getTodaysData } from "../../../common/Validations";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import ItemServiceV2 from "../../../services/supplier_appCommonService";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { getDelegationList } from "../../../redux/feature/supplier_app/sourcingSlice";
import { useDispatch } from "react-redux";

const DelegationUpdateModal = React.forwardRef((props, ref) => {
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const dispatch = useDispatch();

  /* pop failure modal data*/
  const FailureFuelEntry = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureFuelEntry] = useState(FailureFuelEntry);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureFuelEntry] = useState(false);

  const [formInputs, setFormInputs] = useState({
    formDate: getTodaysData() || "",
    formUser: "",
    toUser: "",
    budgetSubtoUser: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  });

  const Departments = [
    { id: 1, name: "ADMIN" },
    // { id: 2, name: "IT" },
    // { id: 3, name: "Finance" },
    // { id: 4, name: "Transport" },
  ];

  const toUser = [
    { id: 1, name: "ADMIN" },
    // { id: 2, name: "Equipment" },
    // { id: 3, name: "Travel" },
    // { id: 4, name: "Office Supplies" },
  ];
  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  useEffect(() => {
  if (props.editData) {
    setFormInputs({
      formDate: props.editData.formDate || "",
      toDate: props.editData.toDate || "",
      formUser: props.editData.formUser || "",
      toUser: props.editData.toUser || "",
      remarks: props.editData.remarks || "",
      supportingDocument:
        props.editData.supportingDocument || "",
      documentNumber:
        props.editData.documentNumber || "",
    });
  }
}, [props.editData]);

  useEffect(() => {
    if (!getDropdownData) return;

    const updatedFields = {
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    };

    if (getDropdownData?.textField === "formUser") {
      updatedFields.formUser = getDropdownData?.name;
      updatedFields.formUser = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "toUser") {
      updatedFields.toUser = getDropdownData?.name;
      updatedFields.toUser = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "paymentMode") {
      updatedFields.paymentMode = getDropdownData?.name;
      updatedFields.paymentMode = getDropdownData?.name;
    }

    setFormInputs((prev) => ({
      ...prev,
      ...updatedFields,
    }));
  }, [getDropdownData]);

  //Validations
  // eslint-disable-next-line
  const [validation, setValidation] = useState({
    formDate: getTodaysData() || "",
    formUser: "",
    toUser: "",
    budgetSubtoUser: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  });
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => {
      const updated = { ...prev, [name]: value };

      if (updated.allocatedAmount && updated.actualAmount) {
        updated.remainingAmount =
          Number(updated.allocatedAmount) - Number(updated.actualAmount);
      } else {
        updated.remainingAmount = "";
      }

      return updated;
    });
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    formDate: getTodaysData() || "",
    formUser: "",
    toUser: "",
    budgetSubtoUser: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };

  const handleSave = async () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemServiceV2.addDelegation(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        props.onHide();
        // props.refreshData();
        dispatch(getDelegationList());
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const hideFailureModal = () => {
    setShowFailureFuelEntry(false);
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Delegation 
           {formInputs?.documentNumber && (
    <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
      {formInputs.documentNumber}
    </span>
  )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">DD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Delegation Details</span>
                  <span className="subHeaderTitle">Delegation details</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Department"
                            label={
                              <>
                                <i className="bi bi-person-badge labelIcon"></i>
                                From User
                              </>
                            }
                            placeholder=""
                            data={Departments}
                            id=""
                            iconClassName="dropdownIcon"
                            name="formUser"
                            code="formUser"
                            description="formUser"
                            setValue={formInputs?.formUser}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="toUser"
                            label={
                              <>
                                <i className="bi bi-person-check labelIcon"></i>
                                To User
                              </>
                            }
                            placeholder=""
                            data={toUser}
                            id="toUser"
                            iconClassName="dropdownIcon"
                            name="toUser"
                            code="toUser"
                            description="toUser"
                            setValue={formInputs?.toUser}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Budget Date "
                            label={
                              <>
                                <i className="bi bi-calendar-date labelIcon"></i>
                                From Date
                              </>
                            }
                            name="formDate"
                            id="formDate"
                            value={formInputs?.formDate}
                            onChange={handleInputChange}
                            // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Budget Date "
                            label={
                              <>
                                <i className="bi bi-calendar-event labelIcon"></i>
                                To Date
                              </>
                            }
                            name="toDate"
                            id="toDate"
                            value={formInputs?.toDate}
                            onChange={handleInputChange}
                            // disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            // label="Remarks"
                            label={
                              <>
                                <i className="bi bi-chat-left-text labelIcon"></i>
                                Remarks
                              </>
                            }
                            placeholder=""
                            name="remarks"
                            id="remarks"
                            value={formInputs?.remarks || ""}
                            error={validation.remarks || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={12}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="supportingDocument"
                            name="supportingDocument"
                            // label="Supporting Document"
                            label={
                              <>
                                <i className="bi bi-paperclip labelIcon"></i>
                                Supporting Document
                              </>
                            }
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.supportingDocument || ""}
                          />
                        </Col>
                        <Col
                          xs={8}
                          md={2}
                          lg={2}
                          className="commLeftRightPadding"
                        >
                          {(formInputs?.supportingDocument && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.supportingDocument)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureFuelData={getFailureFuelEntry}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default DelegationUpdateModal;
